import { render, staticRenderFns } from "./new-list-body.component.vue?vue&type=template&id=1ace128f&scoped=true"
import script from "./new-list-body.component.vue?vue&type=script&lang=js"
export * from "./new-list-body.component.vue?vue&type=script&lang=js"
import style0 from "./new-list-body.component.vue?vue&type=style&index=0&id=1ace128f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace128f",
  null
  
)

export default component.exports